import _ from 'lodash'
import { DatesMixin, MasterDataTransformarMixin } from 'src/application/global/mixins'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  mixins: [MasterDataTransformarMixin, DatesMixin],
  props: ['redemptionID', 'operation', 'countryId'],
  computed: {
    ...mapState({
      appSettings: state => state.globalCMP.appSettings,
    }),
    ...mapGetters(['getArea', 'getProductData', 'getKittingData', 'esacPointsRedemptionData']),
    areaData() {
      return this.$helpers.getValue(this, this.getArea.data, {})
    },
    isNewOrder() {
      return !this.redemptionID
    },
    isDisableEditing() {
      return this.redemptionID && this.redemptionID > 0
    },
    getStatusTitle() {
      return this.$helpers.getValue(this.areaData, 'status.title', this.$ts('words.new'))
    },
    isReadOnly() {
      return this.isDisableEditing
    },
    isCartHasItems() {
      return this.$helpers.getValue(this.areaData, 'selected.campaign_selection', []).length > 0
    },
  },
  methods: {
    ...mapActions(['getProductByIdAction', 'getKittingProductByIdAction']),
    async getEsacPointsRedemptionByIdAction(data = false) {
      // Transform data to sale data
      if (!data) {
        data = _.cloneDeep(this.esacPointsRedemptionData)
        let saleData = {
          country_code: this.$helpers.getValue(data, 'country.code', null),
          currency_code: this.$helpers.getValue(data, 'country.currency.code', null),
          country_id: this.$helpers.getValue(data, 'country_id', null),
          status: this.$helpers.getValue(data, 'status', false),
          downline_member_id: this.$helpers.getValue(data, 'user_id', null),
          location_id: this.$helpers.getValue(data, 'transaction_location_id', null),
          location: this.$helpers.getValue(data, 'transaction_location', null),
          stock_location_id: this.$helpers.getValue(data, 'stock_location_id', null),
          stock_location: this.$helpers.getValue(data, 'stock_location', null),
          transaction_date: this.$helpers.getValue(data, 'transaction_date', null),
          voucher: this.$helpers.getValue(data, 'voucher', null),
          remarks: this.$helpers.getValue(data, 'remarks', null),
          cvs: [],
          order_fees: { ...this.$helpers.getValue(data, 'sales_data.order_fees', {}) },
          selected: {
            ...this.$helpers.getValue(data, 'sales_data.selected', {}),
            campaign_selection: [...this.$helpers.getValue(data, 'items', [])],
          },
          sale_id: this.$helpers.getValue(data, 'sale_id', null),
          total_point: this.$helpers.getValue(data, 'total_point', 0),
          document_number: this.$helpers.getValue(data, 'sales_data.document_number', 0),
          invoice_id: this.$helpers.getValue(data, 'sales_data.invoice_id'),
          invoice: this.$helpers.getValue(data, 'sales_data.invoice'),
          ...{ sales_attribute: this.$helpers.getValue(data, 'sales_data.sales_attribute') },
        }
        return saleData
      } else {
        // Transform Sale data to ITokenRedemption data
        return {
          user_id: data.downline_member_id,
          country_id: data.country_id,
          country_code: data.country_id,
          currency_code: data.currency_code,
          amount: data.order_fees.total_gmp,
          location_id: this.$helpers.getValue(data, 'location_id', null),
          stock_location_id: this.$helpers.getValue(data, 'stock_location_id', null),
          items: [...this.$helpers.getValue(data, 'selected.campaign_selection', [])],
          remarks: this.$helpers.getValue(data, 'remarks', ''),
          shipping: {
            ...this.$helpers.getValue(data, 'selected.shipping', {}),
          },
        }
      }
    },
  },
}
